// extracted by mini-css-extract-plugin
module.exports = {"Container":"ReleaseNote_Container__J9PPh","Intro":"ReleaseNote_Intro__InC9h","release":"ReleaseNote_release__10gbl"};